import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie'
import VueRouter from 'vue-router'
import { analytics } from 'shiseido-apis'
import { bus } from './utilities'
import Intro from './components/sections/introduction.vue'
import Quiz from './components/quiz.vue'
import Results from './components/results.vue'
import LifeStyles from './components/sections/life-styles.vue'
import SkinType from './components/sections/skin-type.vue'
import SkinConcerns from './components/sections/skin-concerns.vue'
import Benefit from './components/sections/benefits.vue'
import '../scss/skincare-consultation.scss'

Vue.use(VueResource)
Vue.use(VueCookie)
Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        { name: 'intro', path: '/', component: Intro },
        {
            name: 'quiz',
            path: '/questions/',
            component: Quiz,
            redirect: '/',
            children: [
                { name: 'life-style',        path: ':gender/:age/', component: LifeStyles },
                { name: 'skin-type',         path: ':gender/:age/:life_style/', component: SkinType },
                { name: 'skin-concerns',     path: ':gender/:age/:life_style/:skin_type/', component: SkinConcerns },
                { name: 'preferred-benefit', path: ':gender/:age/:life_style/:skin_type/:skin_concern/', component: Benefit }
            ]
        },
        { name: 'results', path: '/questions/:gender/:age/:life_style/:skin_type/:skin_concern/:benefit/:saved?', component: Results },
        { name: 'default', path: '*', redirect: '/' }
    ]
})

const app_container = document.getElementById('composed__shiseido-skincare-consultation')

new Vue({
    router,
    watch: {
        $route: 'trackPageView'
    },
    created() {
        bus.$on('next', this.onNext)
    },
    methods: {
        onNext: (path) => router.push({ path }),
        trackPageView() {
            analytics.registerPageView({
                toolname: 'Suncare Finder',
                pagename: this.$route.name
            })

            if (window.innerWidth < 768) {
                window.scrollTo(0, app_container.offsetTop)
            }
        }
    }
}).$mount('#composed__shiseido-skincare-consultation')


// WEBPACK FOOTER //
// ./source/app/js/application-root.js